import PropTypes from 'prop-types';

import {
  ChildrenDefaultProps,
  ChildrenPropTypes,
} from '@/common/proptypes/Base/Children.proptypes';

export const CookiesBannerDefaultProps = {
  ...ChildrenDefaultProps,
  isOpen: false,
  onSubmit: () => null,
  onAcceptAll: () => null,
  onRejectAll: () => null,
};

export const CookiesBannerPropTypes = {
  ...ChildrenPropTypes,
  isOpen: PropTypes.bool,
  onSubmit: PropTypes.func,
  onAcceptAll: PropTypes.func,
  onRejectAll: PropTypes.func,
};
